import React, { useState } from 'react';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import iconwarning from '../../../assets/Forms/WarningBlueIcon.svg';
import { createGlobalStyle } from 'styled-components';

const TabsComponent = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className='global-container'>
      <Styles />
      <div className='button-container'>
        {tabs.map((tab, index) => (
          <Button
            className={activeTab === index ? 'active' : 'tab-button'}
            mode='basic'
            key={index}
            onClick={() => handleTabClick(index)}
          >
            <span style={{ fontSize: '14px', color: activeTab === index ? '#fff' : '#232323', fontWeight: 'bolder' }}>{tab.label}</span>
          </Button>
        ))}
      </div>
      {tabs[activeTab].description && (
        <Container className='icon-container'>
          <img
            className='iconwarning'
            id='iconwarning'
            alt='iconwarning'
            src={iconwarning}
            style={{
              height: '20px',
              width: '20px',
              marginLeft: '90px',
            }}
          />
          <Word
            className='description'
            variant='p'
            textStyle='normalItalic'
            value={tabs[activeTab].description}
          />
        </Container>
      )}

      <Container className='tab-content' key={activeTab}>
        {tabs[activeTab].content}
      </Container>
    </div>
  );
};

const Styles = createGlobalStyle`
.global-container{
    height:100%;
    .button-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        .active {
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          background-color: #008BD2;
          border-radius: 25px;
          cursor: pointer;
          padding: 10px 20px;
        }
    }
    .tab-button {
      background-color: #F4F7FB;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      border-radius: 25px;
      cursor: pointer;
      padding: 10px 20px;
    } 
    .tab-content {
      height:100%;
      margin-top: 20px;
    }
}
.sds-reset-style .icon-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 15px;
  .description{
      margin-left: 15px;
  }
}
`;

export default TabsComponent;
